import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const CustomerDayRegistrationForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const options = new Array(31).map((_, i) => ({
    label: `${i + 1}`.padStart(2, "0"),
    value: i + 1,
  }));

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerDayRegistration}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
